import { render, staticRenderFns } from "./MicrosoftButton.vue?vue&type=template&id=db96f318&scoped=true&"
import script from "./MicrosoftButton.vue?vue&type=script&lang=js&"
export * from "./MicrosoftButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db96f318",
  null
  
)

export default component.exports